var _path, _use, _path2, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPc = function SvgPc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003da5",
    d: "M0 0h640v480H0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(164.3 311.5 242.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pc_svg__a",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.7,
    d: "m472.9 262.8-8.4 1.5-1.1 8.5-4.1-7.5-8.4 1.6 5.8-6.2-4-7.5 7.7 3.6 5.8-6.2-1 8.5z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-10.3 311.5 242.2)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-30.9 311.5 242.2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-20.6 311.5 242.2)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-51.5 311.5 242.2)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-72.1 311.5 242.2)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-61.8 311.5 242.2)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-41.2 311.5 242.2)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-92.7 311.5 242.2)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-113.3 311.5 242.2)"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-103 311.5 242.2)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-133.9 311.5 242.2)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-154.5 311.5 242.2)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-144.2 311.5 242.2)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-123.6 311.5 242.2)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-82.4 311.5 242.2)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-175.1 311.5 242.2)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(174.6 311.5 242.2)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(143.7 311.5 242.2)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(123.1 311.5 242.2)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(133.4 311.5 242.2)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(154 311.5 242.2)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-164.8 311.5 242.2)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(112.8 311.5 242.2)"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(102.5 311.5 242.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00aec7",
    strokeWidth: 13.7,
    d: "M444.9 313A151 151 0 0 1 293 392"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M474.3 288.5S449 277.2 398 277s-105.2 13.9-135.1 13.5c-30-.3-38.8-.3-56.7-3.7 0 0 27 9 55.8 11.6 28.7 2.7 95.2-10.4 128.4-12.5 34-2.1 60.4-2.1 83.8 2.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00aec7",
    d: "M275 303.2s19.2 1 56-3c37-4 63-9.4 92.1-10.2s61.2 4.4 68 6.1c0 0-48.5-1.3-68.8 1.6s-73 9.5-100.7 10.2-37.3-3.2-46.6-4.7m-80.5-27.8s51 13.6 97.2 4.7c52.3-10.2 83-10 106.4-10 23.4-.2 47.9 5.7 47.9 5.7s-96-100.2-196.5-153.3c0 0-7.5 84.5-55 152.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.2 197.5s-1.4-5.3-8.3-4.5c0 0 4.4-2 6.4-1 2 1.1 2.4 1.4 2 5.5m-16.8-9.4s1.5-.5 2.2-.3c0 0 1 3.3 3.2 4.5 0 0-3.8-.3-5.4-4.2m22.2 5a13 13 0 0 0-8.7-4.8c-1.8 0-6 3.5-6 3.5-1-2-.5-3.4-.5-3.4 2 .2 3.7 1 3.7 1-.8-2.6-2-3.8-2-3.8 4-1 8.8 2.5 8.8 2.5a17 17 0 0 0-11-6.8c-1.2-.1-2.7 1.6-2.7 1.6-7.8 0-9.9 4.3-9.9 4.3 3.3 5.1 10 6.3 10 6.3-11.8-1.3-11.5 8-11.5 8l10.9-5.7c-4.2 24.1-21 35-22.4 36.3-1.4 1.4-.5 3 1.5 3.2 1.1 0 2.5 1 6.2-3.4a65 65 0 0 0 16.4-35.4l.2.2c1.2 2.9.4 5.4.6 7.3s4.4 6 4.4 6 2.3-4.5 2-7.1c-.5-2.7-5.5-7.6-5.5-7.6 7.8-1.5 8.2 11.6 8.2 11.6 3-3.5 2.4-7.3 2.4-7.3s6.3-4.6 4.9-6.4"
  })));
};
export default SvgPc;